import { useLoggedInUser } from './useLoggedInUser';

export function useLoggedInUserIsUserById(userId: string): boolean {
	const loggedInUser = useLoggedInUser();
	return loggedInUser.id === userId;
}
